import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth";

export default function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) { toast.success(t("auth.loggedInToast")); nav("/"); }
    else { setErr(r.error); toast.error(r.error); }
  }

  return (
    <div data-testid="login-page" className="px-6 md:px-10 lg:px-16 py-16 md:py-24 max-w-md mx-auto">
      <div className="overline mb-3">{t("auth.breadcrumbLogin")}</div>
      <h1 className="font-display font-bold text-5xl tracking-tighter leading-none mb-8">{t("auth.welcomeBack")}</h1>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="overline block mb-2">{t("auth.email")}</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-line" placeholder={t("auth.emailSample")} />
        </div>
        <div>
          <label className="overline block mb-2">{t("auth.password")}</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-line" placeholder={t("auth.passwordSample")} />
        </div>
        {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
        <button data-testid="login-submit" disabled={busy} className="btn-primary w-full justify-center">{busy ? t("auth.signingIn") : t("auth.signIn")}</button>
      </form>
      <div className="mt-6 text-sm text-gray-600">
        {t("auth.noAccount")} <Link to="/register" data-testid="login-to-register" className="underline">{t("auth.createOne")}</Link>
      </div>
      <div className="mt-10 border-t border-gray-200 pt-4 text-xs text-gray-500 font-mono">
        {t("auth.adminDemo")}
      </div>
    </div>
  );
}
